import { render, staticRenderFns } from "./AddEmployer.vue?vue&type=template&id=11130c78&"
import script from "./AddEmployer.vue?vue&type=script&lang=ts&"
export * from "./AddEmployer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports